module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-footer": true,
      "title": "Barcode connector"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Selecteer de barcode scanner die je wilt gebruiker")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row gutters-tiny"
  }, _vm._l((_vm.barcodeScanners), function(barcodeScanner) {
    return _c('div', {
      key: barcodeScanner.id,
      staticClass: "col-md-6"
    }, [_c('barcode-scanner-type', {
      attrs: {
        "icon": "barcode"
      },
      on: {
        "click": function($event) {
          _vm.connectToBarcodeScanner(barcodeScanner.usb_device)
        }
      }
    }, [_vm._v("\n                " + _vm._s(barcodeScanner.name) + "\n              ")])], 1)
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb8f3534","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/barcode-scanner/BarcodeScannerDetailModal.vue
// module id = 757
// module chunks = 1